export enum UserAction {
  ResidentCreate,
  ResidentUpdate,
  ResidentDelete,
  HealthcareProviderCreate,

  SiteCreate,
  SiteFloorCreate,

  SiteConfigurationUpdate,
  ProfileConfigurationUpdate,
}
